module["exports"] = [
  "кв. ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/address/secondary_address.js
 ** module id = 1126
 ** module chunks = 0
 **/